import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { getUserInfo, isAuthInvalidCode } from '../composables/fetchAPI';

const UserContext = createContext<any>(null);

export const UserProvider = ({ children }: { children: ReactNode }) => {
const [userInfo, setUserInfo] = useState<any>(() => {
    // 1. อ่านค่าจาก localStorage ตั้งแต่ตอนเริ่ม Initialize state
    const savedUser = localStorage.getItem('userInfo');
    return savedUser ? JSON.parse(savedUser) : null;
  });  const [loading, setLoading] = useState(true);

const refreshUser = async (forceUpdate = false) => {
    const token = localStorage.getItem('token');
    if (!token) {
      setLoading(false);
      return;
    }
    // 2. ถ้ามีข้อมูลอยู่แล้ว และไม่ได้สั่ง forceUpdate (เช่น ตอนกดปุ่ม refresh เอง) ให้ข้าม API
    const cachedUser = localStorage.getItem('userInfo');
    console.log(cachedUser)
    if (cachedUser && !forceUpdate) {
      setUserInfo(JSON.parse(cachedUser));
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const info = await getUserInfo();
      setUserInfo(info);
      // 3. บันทึกลง localStorage ทุกครั้งที่มีการดึงใหม่
      localStorage.setItem('userInfo', JSON.stringify(info));
    } catch (error: any) {
      // ถ้าเป็น error code ที่ยืนยันว่า session/token ใช้ไม่ได้จริงๆ (401000, 401200, 401301, 400000)
      // ตัว getUserInfo/handleApiError ใน fetchAPI.ts จะแสดง toast ข้อความเฉพาะของ error นั้นๆ
      // และเคลียร์ token + redirect ไปหน้า login ให้เองอยู่แล้ว (มีดีเลย์ให้อ่าน toast ก่อน)
      // ตรงนี้ไม่ต้องล้าง state/localStorage ซ้ำ แค่เก็บ session เดิมไว้จนกว่าจะถูกเคลียร์จริง
      // ส่วนกรณีเน็ตหลุด/ไม่มี response (error.code เป็น undefined) ก็ข้ามไปเช่นกัน ไม่ต้อง logout
      if (isAuthInvalidCode(error?.code)) {
        console.log('Session invalid, logging out soon:', error?.code);
      }
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    refreshUser();
  }, []);

  return (
    <UserContext.Provider value={{ userInfo, refreshUser, loading }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);